const TOKEN_KEY = "token";
const REQUEST_TIMEOUT_MS = 30000;

export const helpHttp = () => {
  const customFetch = (endpoint, options) => {
    const token = getToken();

    if (token === null || token === "") {
      deleteToken();
      window.location = "/";
      // Evita seguir armando/enviando la petición sin token: se resuelve
      // con el mismo formato de error que usa el resto de la app.
      return Promise.resolve({
        err: true,
        status: "00",
        statusText: "Sesión no válida, redirigiendo al login.",
      });
    }

    const defaultHeader = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    const authorizationHeader = {
      Authorization: token !== null ? `Bearer ${token.token}` : "",
    };

    const controller = new AbortController();
    options.signal = controller.signal;
    //options.mode = "no-cors";

    // Evita que el navegador (o un proxy/CDN intermedio) sirva una respuesta
    // cacheada de un GET anterior. Sin esto, un listado como
    // /creditos/pendientes-abono puede mostrar datos desactualizados tras
    // registrar un abono (ver AbonosView.js) aunque el backend ya esté
    // correcto.
    options.cache = options.cache || "no-store";

    options.method = options.method || "GET";
    options.headers = options.headers
      ? token
        ? { ...defaultHeader, ...options.headers, ...authorizationHeader }
        : { ...defaultHeader, ...options.headers }
      : token
      ? { ...defaultHeader, ...authorizationHeader }
      : defaultHeader;

    options.body = JSON.stringify(options.body) || false;
    if (!options.body) delete options.body;

    const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

    return fetch(endpoint, options)
        .then(async (res) => {
          if (res.ok) {
            return res.json();
          }

          if (res.status === 420) return rutaCerrada();
          if (res.status === 401) return sinPermisos();

          let errorMessage = "Ocurrió un error";

          try {
            const errorData = await res.json();

            if (errorData && errorData.message) {
              // Si el backend envía el detalle técnico en 'error', los juntamos aquí:
              if (errorData.error) {
                errorMessage = `${errorData.message}: ${errorData.error}`;
              } else {
                errorMessage = errorData.message;
              }
            }
          } catch (e) {
            errorMessage = res.statusText || errorMessage;
          }

          return Promise.reject({
            err: true,
            status: res.status || "00",
            statusText: errorMessage, // <-- Aquí ya viajan los dos mensajes juntos
          });
        })
        .catch((err) => {
          // Si ya viene normalizado desde el bloque anterior (errores HTTP), se respeta tal cual.
          if (err && err.err) return err;

          // A partir de aquí solo llegan fallas de red/timeout: fetch rechazado
          // (CORS, DNS, conexión rechazada) o el AbortController disparado por
          // el timeout. Antes esto se devolvía "crudo" (sin .err), lo que hacía
          // que las vistas lo trataran como respuesta exitosa y el loading
          // se quedara pegado al fallar el dispatch con un payload inválido.
          const esTimeout = err && err.name === "AbortError";

          return {
            err: true,
            status: "00",
            statusText: esTimeout
              ? "El servidor tardó demasiado en responder (tiempo de espera agotado). Intente nuevamente."
              : "No se pudo conectar con el servidor. Verifique su conexión e intente nuevamente.",
          };
        })
        .finally(() => clearTimeout(timeoutId));
  };

  const rutaCerrada = () => {
    deleteToken();
    window.location = "/#/mensaje-error/ruta-cerrada";
    return;
  };

  const sinPermisos = () => {
    deleteToken();
    window.location = "/#/login";
    return;
  };

  const get = (url, options = {}) => customFetch(url, options);

  const post = (url, options = {}) => {
    options.method = "POST";
    return customFetch(url, options);
  };

  const put = (url, options = {}) => {
    options.method = "PUT";
    return customFetch(url, options);
  };

  const patch = (url, options = {}) => {
    options.method = "PATCH";
    return customFetch(url, options);
  };

  const del = (url, options = {}) => {
    options.method = "DELETE";
    return customFetch(url, options);
  };

  return {
    get,
    post,
    put,
    patch,
    del,
  };
};

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, JSON.stringify(token));
}

export function getToken() {
  return JSON.parse(localStorage.getItem(TOKEN_KEY));
}

export function deleteToken() {
  //localStorage.removeItem(TOKEN_KEY);
  localStorage.setItem(TOKEN_KEY, null);
}
